<template>
  <div class="">
    <scale-loader
      v-if="charge === true"
      :color="loaderColor"
      class="text-center"
    />
    <div v-if="error !== null">
      <div class="text-center">{{ error }}</div>

      <div class="btn-wrapper pt-100 text-center button">
        <base-button
          class="mb-3 mb-sm-5 btn-lg"
          type="warning"
          icon="ni ni-image"
          @click="getAllCampagne"
        >
          Charger les images
        </base-button>
      </div>
    </div>

    <gallery :images="locations" :index="index" @close="index = null"></gallery>
    <div class="all">
      <div
        class="image"
        v-for="(item, imageIndex) in locations"
        :key="imageIndex"
        @click="index = imageIndex"
        :style="{
          backgroundImage: 'url(' + item + ')',
          width: '300px',
          height: '200px',
        }"
      ></div>
    </div>
  </div>
</template>

<script>
import VueGallery from "vue-gallery";
import galerie from "@/views/myComponent/galerie";
import ScaleLoader from "vue-spinner/src/PulseLoader";

import { db } from "@/main";

export default {
  name: "home",
  components: {
    gallery: VueGallery,
    galerie,
    ScaleLoader,
  },
  data: function() {
    return {
      charge: true,
      loaderColor: "#4da275",
      images: [],
      index: null,
      locations: [],
      errTime: 0,
      error: null,
    };
  },
  created() {
    this.getAllCampagne();
  },
  methods: {
    getAllCampagne() {
      this.charge = true;
      db.collection("galerie")
        .get()
        .then((querySnapshot) => {
          this.charge = false;
          let tab = [];
          querySnapshot.forEach((doc) => {
            tab.push(doc.data());
          });

          for (let item in tab) {
            this.locations.push(tab[item].image.file);
          }
          this.locations = this.locations.reverse();
        })
        .catch((error) => {
          this.errTime = this.errTime + 1;
          if (this.errTime < 6) {
            this.getAllCampagne();
          } else {
            this.error =
              "Veuillez vérifier votre connexion internet et ressayer";
          }

          console.log("Error getting documents: ", error);
        });
    },
  },
};
</script>
<style scoped>
.image {
  float: left;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #ebebeb;
  margin: 5px;
}
.all {
  width: 90%;
  margin-right: auto;
  margin-left: auto;
  padding-left: 20px;
}
@media screen and (max-width: 600px) {
  .image {
    float: none;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    border: 1px solid #ebebeb;
    margin: 5px auto 5px auto;
  }
  .all {
    width: 100%;
    margin-top: 100px;
    padding-left: 0px;
  }
}
</style>
